import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PRELOADER_LOGO } from "../data/assets";

const Preloader = () => {
  const [visible, setVisible] = useState(true);
  const location = useLocation();

  // Initial load
  useEffect(() => {
    const hide = () => setTimeout(() => setVisible(false), 1000);
    if (document.readyState === "complete") {
      hide();
    } else {
      const onLoad = () => hide();
      window.addEventListener("load", onLoad);
      const fallback = setTimeout(hide, 2500);
      return () => {
        window.removeEventListener("load", onLoad);
        clearTimeout(fallback);
      };
    }
  }, []);

  // Route-change flash
  useEffect(() => {
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 900);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div
      className={`preloader ${visible ? "" : "preloader-loaded"}`}
      aria-hidden={!visible}
    >
      <div className="preloader-inner">
        <img src={PRELOADER_LOGO} alt="CASA BALA" className="preloader-logo-spin" />
        <p className="preloader-text-white">CASA BALA</p>
      </div>
    </div>
  );
};

export default Preloader;
